export default "__VITE_ASSET__CWU1wwnn__"